<template>
  <v-container>
    <ValidationObserver ref="objects" v-slot="{ invalid }">
      <v-form>
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="Group" rules="required">
              <v-autocomplete
                v-model="group"
                :loading="loading"
                :items="groups"
                :search-input.sync="search"
                no-data-text="Group not found"
                item-text="title"
                item-value="id"
                auto-select-first
                clearable
                cache-items
                :filter="filterData"
                flat
                hide-no-data
                hide-details
                label="Group"
                return-object
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.title"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.id"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Subgroup" rules="required">
              <v-select
                v-model="duplicate_subgroup_id"
                :disabled="loading"
                :items="listSubGroups"
                :menu-props="{ maxHeight: '400' }"
                item-text="title"
                item-value="id"
                label="Subgroup"
                auto-select-first
                clearable
              ></v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-btn @click="okAction" :disabled="loading || invalid" class="primary">Ok</v-btn>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { mapGetters } from 'vuex';
import store from '@/store/index';

extend('required', required);

export default {
  name: 'SubgroupItineraryItemCopyForm',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: ['subgroup_id'],
  computed: {
    /**
     * The mapGetters helper simply maps store getters to local computed properties:
     */
    ...mapGetters('group', ['loading', 'groups', 'error']),
    /**
     * Get the subgroups from the group
     *
     * @returns array
     */
    listSubGroups() {
      if (this.group) {
        return this.group.subgroups;
      }
      return [];
    }
  },
  watch: {
    search(value) {
      if (this.loading) return false;
      if (value == null || value == '') return false;
      if (value && value.indexOf(',') > 0) return false;
      this.searchTerm = value;
      this.fetchEntriesDebounced();
    },
    group(newGroup) {
      // Reset the subgroup when group changes
      this.subgroup = null;

      // If new group has subgroups, select the first one
      if (newGroup && newGroup.subgroups && newGroup.subgroups.length > 0) {
        this.$nextTick(() => {
          this.subgroup = newGroup.subgroups[0];
        });
      }
    }
  },
  methods: {
    /**
     * Filter autocomplete, so we can select via id or title
     */
    filterData(item, queryText) {
      return item.title.toLowerCase().includes(queryText.toLowerCase()) || item.id == queryText.toLowerCase();
    },
    /**
     * Fetch the groups with a debounced event to reduce calls to server
     */
    fetchEntriesDebounced() {
      clearTimeout(this.timerID);
      this.timerID = setTimeout(() => {
        this.searchGroups();
      }, 1000);
    },
    /**
     * Search for the groups
     */
    searchGroups() {
      store.dispatch('group/search', {
        keyword: this.searchTerm
      });
    },
    /**
     * Save method for the form
     */
    async okAction() {
      if (parseInt(this.duplicate_subgroup_id, 10) > 0 && this.subgroup_id > 0) {
        await store.dispatch('itineraryItem/copyItineraryItemsFromSubgroup', {
          subgroup_from_id: this.duplicate_subgroup_id,
          subgroup_to_id: this.subgroup_id
        });
      }
      this.$emit('closed');
    }
  },
  data: () => ({
    group: null,
    search: null,
    timerID: null,
    searchTerm: null,
    duplicate_subgroup_id: null
  })
};
</script>
